module.exports = __webpack_public_path__ + "files/68f62b6b81baafdf11011f0f00d92742.png";